
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";
import { imageKitResize, parsePx } from "utils/imageKit";

const Image = (props) => {
  // Add lazy loading by default unless explicitly disabled. w/h are pulled out
  // so they never leak onto the <img> as invalid DOM attributes.
  const { loading = "lazy", w, h, ...restProps } = props;
  const { src, type, style } = props;

  let finalSrc = src;
  if (src) {
    // Render at 2x for retina crispness. Size is taken per call site:
    // explicit w/h prop first, else the element's own pixel style; avatars
    // fall back to 160. Other images with no size hint (asset photos in a
    // detail view, for instance) are served at full size. imageKitResize
    // only touches ImageKit-hosted URLs, so external images pass through.
    const dpr = 2;
    const styleW = parsePx(style?.width);
    const styleH = parsePx(style?.height);
    const baseW = w || styleW || styleH || (type === "user" ? 160 : null);
    const baseH = h || styleH || styleW || baseW;
    if (baseW) finalSrc = imageKitResize(src, baseW * dpr, baseH * dpr);
  }

  return (
    <img
      {...restProps}
      loading={loading}
      src={
        finalSrc ||
        require(`assets/img/${type == "user" ? "user.jpg" : "placeholder.webp"}`)
      }
    />
  );
};
export default Image;
